import axios from "axios";
import React, { Component } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import CustomerInfoTable from "./common/CustomerInfoTable";
import CustomerInfoTable_New from "./common/CustomerInfoTable_New";
import USPriceTable from "./common/USPriceTable";
import ReactToPrint from "react-to-print";
import ReportHeader from "./common/ReportHeader";
import ReportFooter from "./common/ReportFooter";
import { Link } from "react-router-dom";
import USCarSVG from "../carbodyparts/USCarSVG";
import './reportminius.css'
import './ReportMiniEU.css'
import { configuration } from "../appConfig";
import ReportFooter_New from "./common/ReportFooter_New";
import ReportHeader_New from "./common/ReportHeader_New";
import ScrollToTop from "./common/ScrollToTop";
import './common/allImagesReport.css';
import './common/allImagesReportPrintMode.css';
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import DetailedReportAuthorization from "./common/DetailedReportAuthorization";
export class ReportMiniEU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      words: {},
      lang: "",
      jsonData: {},
      orderId: "",
      isAnyOnecheck : false

    };
  }

  componentDidMount() {
    this.getLang();
    this.getOrderId()
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang, words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getOrderId = () => {
    axios.get(configuration.getData, {
      params: {
        vin: localStorage.getItem('selectedFile'),
        partnerId: localStorage.getItem('partnerId')
      }
    }).then((res) => {
      if (res && res.data) {
        this.setState({
          orderNo: res.data.hasOwnProperty('OrderNo') ? res.data.OrderNo : "",
          jsonData: res.data,
        }, () => this.checkStatus());      }
    }).catch(err => console.log(err))
  }

  changeAuthorizeFlag = (authorize, driveType) => {
    this.setState({
      jsonData: {
        ...this.state.jsonData,
        Authorized: authorize,
        DriveThrough: driveType === 'drive_through' ? "0" : driveType === 'drive_in' ? "1" : "",
      },
    });
  }
  checkStatus = () => {
    const { jsonData } = this.state;
    const isAnyOnecheck = jsonData && jsonData.Dents && jsonData.Dents.some(item => item.Ersetzen && item.Ersetzen.length > 0);
    this.setState({ isAnyOnecheck });
  }

  render() {
    const { orderNo, jsonData, lang } = this.state;
    return (
      <div className="animated fadeIn report_mini_eu_main">
        {/* <div className="container-fluid card_heading_main_bg"> */}
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small>
                      {" "}
                      {/* <span>{this.lang("Estimate Id")} :</span>{" "}
                          {orderNo ||localStorage.getItem("selectedFile")} */}
                      <b>{this.lang("VIN")} </b>: {localStorage.getItem("selectedFile")}
                    </small>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {/* <ReportAuthorizationHandler
                            jsonData={jsonData}
                            lang={this.lang}
                            reportType={"mini_eu"}
                            isRemoveDriveThroughButton={true}
                            isAuthorized={jsonData.Authorized}
                            changeAuthorizeFlag={(authorize, driveType) => this.changeAuthorizeFlag(authorize, driveType)}
                            selectedLanguage={lang}
                          /> */}
                      <DetailedReportAuthorization />
                      <ReactToPrint
                        trigger={() => {
                          document.title =
                            document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg pull-right">
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <div
            className="container reportmini all_report_wrapper_swiss"
            // id="divIdToPrint"
            ref={(el) => (this.componentRef = el)}
            style={{ padding: 0 }}
          >
            <div className="row row-zero page-break-row report-full-wrapper us-top-table-wrapper" data-content-name={this.lang("Page")}>
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <CustomerInfoTable />
                      {/* <CustomerInfoTable_New /> */}
                      <USPriceTable viewType="reportMiniEU" />
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss />
                </Card>
              </div>
            </div>
            {this.state.isAnyOnecheck &&
                    <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                      <div className="col-sm-12 full-height-col col-zero">
                        <Card>
                          <CardBody className="col-zero">
                            <div className="newFormatReport_wrapper">
                              <ReportHeader_Swiss />
                              <USPriceTable is_extra_columns_visible_mini_fullreport={true} />
                              {/* <div className="p-0 row ">
                        </div> */}
                            </div>
                          </CardBody>
                          <ReportFooter_Swiss />
                        </Card>
                      </div>
                    </div>}
            <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
              <div className="col-sm-12 full-height-col col-zero">
                <Card>
                  <CardBody className="col-zero">
                    <div className="newFormatReport_wrapper">
                      <ReportHeader_Swiss />
                      <div className="container car-svg-main">
                        <div className="row title-row-main">
                          <div
                            // style={{ marginTop: "0rem" }}
                            className="col-sm-12 col-zero"
                          >
                            <h3 className="report-title">
                              {this.lang("2D View")}
                            </h3>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <USCarSVG {...this.props}/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <ReportFooter_Swiss />
                </Card>
              </div>
            </div>
          </div>
          {/* <div>
            <Card>
              <CardBody>
                <Link className="glass" to="/ReportFull">
                  <button className="btn btn-danger btn-sm pull-right">
                    <i className="fa fa-dot-circle-o"></i> {">>"}
                  </button>
                </Link>
                <Link className="glass" to="/TabView">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn btn-danger btn-sm pull-right"
                  >
                    {"<<"} <i className="fa fa-dot-circle-o"></i>
                  </button>
                </Link>
              </CardBody>
            </Card>
          </div> */}
          <ScrollToTop />
        </div>
      </div>
    );
  }
}

export default ReportMiniEU;
